"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFlashOrder = void 0;
const routes_1 = require("../../routes");
const createFlashOrder = (client) => async (payload) => {
    const url = routes_1.ENDPOINTS.CREATE_FLASH_ORDER.path;
    const response = await client.post(url, payload, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response.data;
};
exports.createFlashOrder = createFlashOrder;
